/** Consume UTF-8 JSON records without waiting for the slowest response item. */
export async function consumeJsonLines(response: Response, receive: (value: any) => void): Promise<void> {
    if (!response.ok) {
        const data = await response.json().catch(() => ({error: response.statusText}));
        throw Object.assign(new Error(data.error || 'The data request failed.'), {response: {status: response.status, data}});
    }
    if (!response.body) throw new Error('The data response did not contain a stream.');
    const reader = response.body.getReader(), decoder = new TextDecoder();
    let buffer = '';
    try {
        while (true) {
            const {done, value} = await reader.read();
            buffer += decoder.decode(value, {stream: !done});
            let newline: number;
            while ((newline = buffer.indexOf('\n')) >= 0) {
                const line = buffer.slice(0, newline).trim();
                buffer = buffer.slice(newline + 1);
                if (line) receive(JSON.parse(line));
            }
            if (done) {
                if (buffer.trim()) receive(JSON.parse(buffer));
                return;
            }
        }
    } catch (error) {
        await reader.cancel().catch(() => undefined);
        throw error;
    } finally { reader.releaseLock(); }
}
